import Vue from 'vue'
import Vuex from 'vuex'
import firebase from "firebase";
import * as Firebase from 'firebase/app'
import {uuid} from 'vue-uuid'
import createEasyFirestore from 'vuex-easy-firestore'
const axios = require('axios')
Vue.use(Vuex)

import myModule from './modules/myModule.js'
import templates from './modules/templates.js'
import strutture from './modules/strutture.js'

const easyFirestore = createEasyFirestore(
  [myModule,templates,strutture],
  {logging: true, FirebaseDependency: Firebase} // pass Firebase like this. Mind the Capital F!
)



export default new Vuex.Store({
  plugins: [easyFirestore],
  state: {
    APIURL: 'https://us-central1-hrcrm-439b3.cloudfunctions.net/webApi/api/v1',
    HRAPIURL:'https://beta.hotelrunner.it/hrapi/API',
    APIKEY:'TT-TEST0001',
    config: {
      facebook_page_id: 1828383987376617
    },
    user: {
      loggedIn: false,
      data: null
    },
    preventivo: {},
    strutturacorrente:{}

  },
  getters: {
    user(state){
      return state.user
    }
  },
  mutations: {
   SostituisciTag(str){
      var retval = str;
    
      if(str){
        for (const key in this.preventivo) {
          // eslint-disable-next-line no-prototype-builtins
          if (this.preventivo.hasOwnProperty(key)) {
              const element = this.preventivo[key];
    
              console.log("REPLACE",key,element)
              retval = str.replace("{{"+key+"}}", element);
    
    
    
          }
        }
      }
    
      return retval;
    },
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SETPRENOTAZIONE(state, data) {
      //applico il template base
      //...
      const template_base = state.templates[data.idtemplate]
      state.preventivo = {...state.preventivo, ...template_base }
      
      

      //sostituisco i tag nel template
      for(var property in data){  
        if(typeof data[property] =="string"){
          if(data[property].includes("{{")){
            let begin = data[property].indexOf("{{")
            let end = data[property].indexOf("}}")
            let par = data[property].slice(begin+2,end)
            data[property] = data[property].replace("{{"+par+"}}",data[par])
          }         
        }
      }
      state.preventivo = data;
    },
    SETTESTI(state, data) {
      state.preventivo.testiaggiuntivi = data;
    },
    ADDTESTO(state, data) {
      state.preventivo.info.push({ testo: data.testo, titolo: data.titolo });
    },
    DELTESTO(state, data) {
      const index = state.preventivo.info.indexOf(data);
      if (index > -1) {
        state.preventivo.info.splice(index, 1);
      }
    },
    APPLYTEMPLATE(state, data) {
      const template_da_salvare = {...data}
      delete template_da_salvare.id
      delete template_da_salvare.idcliente
      const merge= {...state.preventivo, ...template_da_salvare }
      state.preventivo = merge
      console.log('applico template',template_da_salvare)
      //sostituisco i tag nel preventivo
      for(var property in state.preventivo){  
        if(typeof state.preventivo[property] =="string"){
          if(state.preventivo[property].includes("{{")){
            let begin = state.preventivo[property].indexOf("{{")
            let end = state.preventivo[property].indexOf("}}")
            let par = state.preventivo[property].slice(begin+2,end)
            state.preventivo[property] = state.preventivo[property].replace("{{"+par+"}}",state.preventivo[par])
          }         
        }
      }
    },
    SETSTRUTTURA(state,idstruttura){
      state.strutturacorrente = idstruttura
    }
  },
  actions: {
    fetchUser({ commit,dispatch }, user) {
      commit("SET_LOGGED_IN", user !== null);
      const me =this
      if (user) {
        console.log(user)
        dispatch("templates/fetchAndAdd", {
          where: [["idcliente", "==", user.uid]]
        })
        console.log("carico strutture...",me.state.strutturacorrente)

        dispatch("strutture/fetchAndAdd", {
          where: [["idcliente", "==", user.uid]]
        }).then(risp=>{
          console.log("carico strutture e imposto struttura corrente da",risp)
          if(risp){
              console.log("imposto struttura",risp.docs,risp.docs[0].id)
              commit("SETSTRUTTURA",risp.docs[0].id)
          }
        })
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email,
          providerData:{idcliente:user.idcliente}
        });
      } else {
        commit("SET_USER", null);
      }
    },
    getPreventivo({ commit }, dati) {
      return new Promise((resolve, reject) => {
        var URL = this.state.APIURL + "/preventivi/" + dati.idpreventivo
        if(dati.template){
          URL +="?t="+dati.template
        }

        console.log(URL)
        // Make a request for a user with a given ID
        axios.get(URL).then(response => {
          // http success, call the mutator and change something in state
          
          commit('SETPRENOTAZIONE', response.data)
          resolve(response);  // Let the calling function know that http is done. You may send some data back
        }, error => {
          // http failed, let the calling function know that action did not work out
          reject(error);
        })
      })
    },
    getPreventivoMob({ commit }, dati) {
      return new Promise((resolve, reject) => {
        //var URL = this.state.APIURL + "/preventivi/" + dati.idpreventivo
        
        let data = JSON.stringify({
          "p": {
            "comando": "br_get_preventivo",
            "dati": {
              "id": dati.idpreventivo,//"0E375204-E9B9-4AED-8078-F79589D85C30",
            }
          }
        });
        
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: 'https://gamma.hotelrunner.it/hrapitest/V2',
          headers: { 
            'X-HTTP-Method-Override': 'ApiRequest', 
            'token': 'TT-TEST0001', 
            'Content-Type': 'application/json'
          },
          data : data
        };
        
        axios.request(config)
        .then((response) => {
          console.log("PREVEMOBILE",response.data);
          commit('SETPRENOTAZIONE', response.data.data.preventivo);
          resolve({data:response.data.data.preventivo});  
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
        // Make a request for a user with a given ID

      })
    },
    getTesti({ commit }, idcliente) {
      return new Promise((resolve, reject) => {
        var URL = this.state.APIURL + "/texts/" + idcliente
        console.log(URL)
        // Make a request for a user with a given ID
        axios.get(URL).then(response => {
          // http success, call the mutator and change something in state
          commit('SETTESTI', response.data)
          console.log('TESTI', response.data)
          resolve(response);  // Let the calling function know that http is done. You may send some data back
        }, error => {
          // http failed, let the calling function know that action did not work out
          reject(error);
        })
      })
    },
    // eslint-disable-next-line no-unused-vars
    getStrutturaHR({ commit }, Apikey) {
      return new Promise((resolve, reject) => {
        var URL = this.state.HRAPIURL 
        console.log(URL)
        // Make a request for a user with a given ID
        axios({
          method: 'POST',
          url: URL,
          headers: { 'content-type': 'application/json', 'X-HTTP-Method-Override':'GetDatiStrutturaMiniSito','token':Apikey },
          data: null
  
        }).then(response => {
          // http success, call the mutator and change something in state
          resolve(response);  // Let the calling function know that http is done. You may send some data back
        }, error => {
          // http failed, let the calling function know that action did not work out
          reject(error);
        })
      })
    },
        // eslint-disable-next-line no-unused-vars
    APIRequestHR({ commit }, payload) {
          return new Promise((resolve, reject) => {
            var URL = this.state.HRAPIURL 
            console.log(URL,this.state.APIKEY ,JSON.stringify(payload))
            // Make a request for a user with a given ID
            axios({
              method: 'POST',
              url: URL,
              headers: { 'content-type': 'application/json', 'X-HTTP-Method-Override':'APIRequest','token':this.state.APIKEY },
              data: {Param:JSON.stringify(payload)}
      
            }).then(response => {
              // http success, call the mutator and change something in state
              resolve(response);  // Let the calling function know that http is done. You may send some data back
            }, error => {
              // http failed, let the calling function know that action did not work out
              reject(error);
            })
          })
        },
    addTesto({ commit }, testo) {
      commit('ADDTESTO', testo)
    },
    delTesto({ commit }, testo) {
      commit('DELTESTO', testo)
    },
    updatePreventivo({ commit }) {

      var URL = this.state.APIURL + "/preventivi/" + this.state.preventivo.id
      // Make a request for a user with a given ID
      axios({
        method: 'put',
        url: URL,
        headers: { 'content-type': 'application/json' },
        data: this.state.preventivo

      }).then(response => {
        // JSON responses are automatically parsed.
        commit('PRENOAGGIORNATA', response.data)
        console.log('fatto', response.data);
      })
        .catch(e => {
          console.log(e);
        })
    },
    // eslint-disable-next-line no-unused-vars
    saveAsTemplate({ commit,dispatch }, dati) {
      
      
      // Make a request for a user with a given ID
      const p = this.state.preventivo
      delete p.soluzioni
      delete p.nominativo
      delete p.guidclientehr
      delete p.nominativo
      delete p.idtemplate
      p.guidstrutturahr = this.state.strutturacorrente
      p.id = uuid.v1()
      p.idcliente = firebase.auth().currentUser.uid
      p.descrizionetemplate = dati.descrizionetemplate
      dispatch('templates/set', p)      
    },
    applyTemplate({ commit }, idtemplate) {
      const templ = this.state.templates.data[idtemplate]
      if(templ)
      {
        commit('APPLYTEMPLATE', templ)
      }
    },
    SetStrutturaCorrente({ commit }, idstruttura)
    {
        commit('SETSTRUTTURA',idstruttura)
    },
    getPreventivohr({ commit }, idpreno) {
      var URL = 'http://beta.hotelrunner.it/hrapi/API'
      var token = 'TT-TEST0001'
      idpreno = '797505'
      // Make a request for a user with a given ID
      axios({
        method: 'post',
        url: URL,
        headers: { 'content-type': 'application/json', 'X-HTTP-Method-Override': 'GetPrenotazione', 'token': token },
        data: { IdPrenotazione: idpreno }

      }).then(response => {
        // JSON responses are automatically parsed.
        console.log('estratto conto', response.data);
        commit('SETPRENOTAZIONE', response.data)

      })
        .catch(e => {
          console.log(e);
        })
    }
  },
  modules: {
  }
})
